import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Lab MemberShip
function createLabMemberShip(params: any) {
    const baseUrl = `/memberShip/createMemInfo`;
    return api.create(`${baseUrl}`, params);
}
// update Lab MemberShip
function updateLabMemberShip(params: any) {
    const baseUrl = '/memberShip/updateMemInfo';
    return api.update(`${baseUrl}`, params);
}

// get all Lab MemberShip
function getAllLabMemberShip(params: any) {
    const baseUrl = '/memberShip/getMemInfo';
    return api.create(`${baseUrl}`, params);
}

// get Lab MemberShip
function getLabMemberShip(params: any) {
    const baseUrl = '/memberShip/getMemDetail';
    return api.create(`${baseUrl}`, params);
}

export { createLabMemberShip, updateLabMemberShip, getAllLabMemberShip, getLabMemberShip };
